export default {
    key: 'unlimited-pass-winter',
    type: 'Activity',
    isUsingProductConfigPresets: false,
    isUsingProductPresets: true,
    hideCrossSells: false,
    disablePassengers: false,
    isLoadingPassengerOffers: true,
    isRental: false,
    activityId: 'e47b380f-892d-427a-8b5f-beb00f1ffcc7',
    categoryId: undefined,
    defaultDuration: undefined,
    isMultiDay: false,
    isUsingReductionCards: true,
    isUsingKeyCards: true,
    hidePassengerMeasurements: false,
    isUsingPromos: true,
    isPromotionRequired: false,
    showDuration: false,
    upsells: [],
    salesTimeLimit: undefined,
    isUpsellDatesRestricted: false,
    maxNumberOfPeople: undefined,
    maxNumberOfPeopleGroupTariff: undefined,
    isUsingSeasonDates: true,
    defaultPassengerAge: 30,
    hiddenProductReductionCard: undefined,
    listingId: 'e47b380f-892d-427a-8b5f-beb00f1ffcc7',
    contentfulId: 'unlimited-pass-winter',
    steps: [],
} satisfies ProductConfigActivity;
